import { observer } from 'mobx-react-lite';
import { FC, useCallback } from 'react';

import { useCallContext } from '@gem/call/CallView/CallView.context';
import { WaitingRoomRequestStatus } from '@gem/call/Model/callModel.types';
import { useTranslation } from '@gem/modules/i18n';

import styles from './AdmitAllButton.styles.m.css';

export const AdmitAllButton: FC = observer(() => {
  const { t } = useTranslation();
  const context = useCallContext();

  const onClick = useCallback(() => {
    context.callController.updateWaitingRoomForAll(WaitingRoomRequestStatus.Approve);
  }, []);

  return (
    <button
      className={styles.link}
      onClick={onClick}
    >
      <span className={styles.text}>{t('calls_participants_admit_all_button')}</span>
    </button>
  );
});
